export const SNACKBAR_MESSAGE = "SNACKBAR_MESSAGE";